import React, { ReactElement, useEffect, useState } from 'react';
import winImage from '../../../../assets/png/text_win.png';
import loseImage from '../../../../assets/png/text_lose.png';
import drawImage from '../../../../assets/png/text_draw.png';
import './LiveMatchResult.scss';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import { convertDataToUID } from '../../../../common/utils/utils';
import { LiveCompetitionResult } from '../../../../services/api/models/response/responseLiveMatch';

type Result = LiveCompetitionResult | null;
type ResultState = { userLive: Result; userTarget: Result };

const LiveMatchResult = (): ReactElement => {
  const { liveCompetitions, isFinishLiveCompetition } = useSelector(
    (state: AppState) => state.liveMatch,
  );
  const liveData = useSelector((state: AppState) => state.live.liveData);
  const [result, setResult] = useState<ResultState>({
    userLive: null,
    userTarget: null,
  });
  const isTargetUser = liveData?.id !== liveCompetitions?.liveMatch.live.id;

  useEffect(() => {
    if (liveCompetitions) {
      const hashUserLive = convertDataToUID(
        liveCompetitions.liveMatch.live.user.id,
      );
      const hashUserTarget = convertDataToUID(
        liveCompetitions.liveMatch.target.user.id,
      );
      const elementLive = liveCompetitions?.scores.find(
        (item) => convertDataToUID(item.user.id) === hashUserLive,
      );
      const elementTarget = liveCompetitions?.scores.find(
        (item) => convertDataToUID(item.user.id) === hashUserTarget,
      );
      if (elementLive && elementTarget) {
        setResult({
          userLive: elementLive.result,
          userTarget: elementTarget.result,
        });
      }
    }
  }, [liveCompetitions?.scores]);

  const getResultImg = (result: Result) => {
    if (
      result === LiveCompetitionResult.Win ||
      result === LiveCompetitionResult.ByeWin
    ) {
      return winImage;
    } else if (
      result === LiveCompetitionResult.Lose ||
      result === LiveCompetitionResult.Abstention
    ) {
      return loseImage;
    } else if (result === LiveCompetitionResult.Draw) {
      return drawImage;
    } else return '';
  };

  return (
    <>
      {isFinishLiveCompetition && (
        <>
          <div className="live-match-result-left">
            <img
              src={getResultImg(
                isTargetUser ? result.userTarget : result.userLive,
              )}
              alt=""
            />
          </div>
          <div className="live-match-result-right">
            <img
              src={getResultImg(
                isTargetUser ? result.userLive : result.userTarget,
              )}
              alt=""
            />
          </div>
        </>
      )}
    </>
  );
};
export default LiveMatchResult;
